<template>
  <div>
    <v-overlay
      v-model="showSuccess"
      :scrim="true"
      opacity="0.3"
      persistent
      :z-index="9900"
    >
    </v-overlay>
    <transition name="fade-slide">
      <output v-if="showSuccess" class="success-toast">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 15px; font-weight: 600;">{{ successMessage }}</span>
      </output>
    </transition>
    <v-container fluid>
      <h2 class="heading-text">{{ $t('intentSessionInformation') }}</h2>

      <div class="mt-2 mb-4">
        <hr />
      </div>

      <v-card class="card2">
        <v-row class="items-center">
          <v-col cols="12" sm="3">
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                {{ $t('intentSessionName') }}
              </label>
              <span style="color: red; margin-left: 4px;">*</span>
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t('_nameIntentSessionTooltip') }}</span>
              </v-tooltip>
            </div>
            <v-text-field
              id="intentsessionname-intentsessiondetail"
              v-model="Request.Name"
              variant="outlined"
              density="comfortable"
              :placeholder="$t('intentSessionName')"
              hide-details
              color="grey"
            />
          </v-col>

          <!-- Priority -->
          <v-col cols="12" sm="2">
            <div class="mb-1 d-flex align-center" style="gap: 4px">
              <label for="priority" class="text-sm font-medium text-gray-700">{{ $t('priority') }}</label>
              <v-tooltip location="top" max-width="240px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t('_priorityTooltip') }}</span>
              </v-tooltip>
            </div>
            <v-text-field
              id="score-intentsessiondetail"
              v-model="Request.Score"
              variant="outlined"
              density="comfortable"
              :placeholder="$t('priority')"
              hide-details
              color="grey"
              @keypress="isNumberpositive($event)"
            />
          </v-col>

          <v-col col="6" sm="1" style="display: flex; justify-content: center; margin-top: 4px;">
            <div class="action-divider"></div>
          </v-col>

          <!-- Use Memory -->
          <v-col cols="12" sm="3">
            <div class="card-box use-memory-card" :class="Request.UseMemory ? 'state-on' : 'state-off'">
              <div class="cart-top">
                <img src="@/assets/Frame.svg" alt="img" width="18" height="18" />
                <span style="font-weight: 600; font-size: 12px; color: #171717;">{{ $t('useMemory') }}</span>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>{{ $t('_useMemoryTooltip') }}</span>
                </v-tooltip>
              </div>
              <div class="cart-bottom mt-1">
                <span style="font-weight: 500; font-size: 11px; color: #171717;">{{ $t('enableMemoryForIntent') }}</span>
                <v-switch v-model="Request.UseMemory" class="memory-switch" hide-details></v-switch>
              </div>
            </div>
          </v-col>

          <!-- Use Base Prompt -->
          <v-col cols="12" sm="3">
            <div class="card-box use-memory-card" :class="Request.UseBasePrompt ? 'state-on' : 'state-off'">
              <div class="cart-top">
                <img src="@/assets/fluent_prompt-16-filled.svg" alt="img" width="18" height="18" />
                <span style="font-weight: 600; font-size: 12px; color: #171717;">{{ $t('useBasePrompt') }}</span>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>{{ $t('_useBasePromptTooltip') }}</span>
                </v-tooltip>
              </div>
              <div class="cart-bottom mt-1">
                <span style="font-weight: 500; font-size: 9px; color: #171717;">{{ $t('mergeBasePromptWithAction') }}</span>
                <v-switch v-model="Request.UseBasePrompt" @change="toggleAllMergePrompt" class="memory-switch" hide-details></v-switch>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-row style="margin-top: -28px;">
        <v-col cols="12" sm="12" md="12">
          <div class="mb-3 d-flex align-center mt-3" style="gap: 4px">
            <img src="@/assets/picen.svg" alt="img" width="16" height="16" />
            <h4 for="label" class="heading-text">
              Set Prompt for Intent Detection
            </h4>
          </div>
          <v-textarea
            id="prompt-intentsessiondetail"
            variant="plain"
            v-model="Request.PromptSession"
            :placeholder="$t('_enterAPrompt')"
            hide-details="auto"
            class="textarea-style"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <div class="intent-panel-body" :class="showDialog ? 'intent-panel-open' : 'intent-panel-closed'" @click="showDialog = !showDialog">
            <div class="intent-left">
              <img :src="showDialog ? iconGoalsWhite : iconGoalsColor" alt="Example" width="16" height="16" />
              <span :style="{ color: showDialog ? '#ffffff' : '#171717' }" class="example-text">{{ $t('exampleQuestions') }}</span>
            </div>
            <button type="button" class="intent-right">
              <img
                v-if="!showDialog"
                src="@/assets/lets-icons_arrow-drop-down.svg"
                alt="expand"
                width="16"
                height="16"
              />
              <img
                v-else
                src="@/assets/lets-icons_arrow-drop-up.svg"
                alt="collapse"
                width="16"
                height="16"
              />
            </button>
          </div>
        </v-col>
      </v-row>

      <!-- Example Question Card -->
      <v-card class="card-design mt-6" v-show="showDialog">
        <v-card-title>
          <div class="card-header">
            <div class="card-title">
              <img src="@/assets/message.svg" alt="img" width="16" height="16" />
              <span style="font-weight: 700; color: #171717; font-size: 14px;">{{ $t('exampleQuestions') }}</span>
            </div>
            <div class="card-title">
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <button @click="downloadTemplate()" class="template-btn" v-bind="props">
                    <img src="@/assets/lucide_download.svg" alt="img" width="16" height="16" />
                    <span style="color: #C32E0E; font-size: 13px">{{ $t('template') }}</span>
                  </button>
                </template>
                <span>{{ $t('_downloadTemplates') }}</span>
              </v-tooltip>
              
              <DragDropFile
                id="uploadfile-intentsessiondetail"
                :dialog="true"
                :DragDrop="false"
                :ShowListFile="false"
                accept=".xlsx"
                @filesUploaded="processUpload($event)"
                :allowType="[
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                ]"
                class="UploadFile"
              />
            </div>
          </div>
        </v-card-title>
        <div style="margin-top: -10px;">
          <hr />
        </div>

        <div class="example-questions-wrapper">
          <div
            v-for="(item, index) in Intent"
            :key="'example-' + index"
            class="example-input-row"
          >
            <div class="example-info-icon">{{ index + 1 }}</div>
            <input
              :id="'examplequestion-intentsessiondetail-' + index"
              v-model="item.text"
              type="text"
              class="example-input"
              :placeholder="$t('_enterExampleQuestion')"
              @keypress="isEnter($event, index)"
              @keypress.enter="newLineEnter(index)"
              @paste="onPaste(index, $event)"
              @keyup.delete="CheckDeleteIntent(index, item.text)"
            />
            <button
              :id="'button-delete-example-intentsessiondetail-' + index"
              v-show="index + 1 < Intent.length"
              class="example-delete-btn"
              @click="Intent.splice(index, 1)"
              type="button"
              :aria-label="$t('_deleteExampleQuestion')"
            >
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/Group.svg"
                    alt="info"
                    width="20"
                    height="17"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t('delete') }}</span>
              </v-tooltip>
            </button>
          </div>
        </div>
      
        <div style="margin-top: 4px;">
          <hr>
        </div>
        <v-card-actions style="padding: 12px 20px;">
          <button class="add-example-section" @click="isEnter($event, Intent.length - 1)">
            <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
            <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">{{ $t('addExample') }}</span>
          </button>
        </v-card-actions>
      </v-card>

      <v-row class="mt-2">
        <v-col cols="12" sm="12">
          <div class="intent-panel-body" :class="showActionDialog ? 'intent-panel-open' : 'intent-panel-closed'" @click="showActionDialog = !showActionDialog">
            <div class="intent-left">
              <img :src="showActionDialog ? iconActionOpen : iconActionClose" alt="Action" width="16" height="16" />
              <span :style="{ color: showActionDialog ? '#ffffff' : '#171717' }" class="action-text">{{ $t('intentAction') }}</span>
            </div>
            <button type="button" class="intent-right">
              <img
                v-if="!showActionDialog"
                src="@/assets/lets-icons_arrow-drop-down.svg"
                alt="expand"
                width="16"
                height="16"
              />
              <img
                v-else
                src="@/assets/lets-icons_arrow-drop-up.svg"
                alt="collapse"
                width="16"
                height="16"
              />
            </button>
          </div>
        </v-col>
      </v-row>

      <!-- Intent Action Card -->
      <v-card class="card-design" v-show="showActionDialog">
        <v-card-title>
          <div class="card-action-title mt-2">
            <img src="@/assets/fluent_sparkle-action-24-filled.svg" alt="img" width="16" height="16" />
            <span style="font-weight: 700; color: #171717; font-size: 14px;">{{ $t('intentAction') }}</span>
          </div>
        </v-card-title>
        <div style="padding: 0 18px; margin-top: 4px;">
          <hr />
        </div>

        <div
          v-for="(items, indexs) in Request.IntentActions.filter(
            (e) => e.activeFlag == true
          )"
          :key="indexs + 'a'"
          class="action-section"
        >
          <v-row class="mb-2" v-if="!items.isParallelAction && indexs == 0">
            <v-col md="6" sm="12">
              <div style="gap: 2px; margin-bottom: 2px;">
                <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                  {{ $t('actionType') }}
                </label>
                <span style="color: red; margin-left: 4px;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="16"
                      height="16"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>{{ $t('_actionTypeTooltip') }}</span>
                </v-tooltip>
              </div>

              <v-autocomplete
                class="validation-type-autocomplete"
                :id="'actiontype-intentsessiondetail-' + indexs"
                variant="outlined"
                :placeholder="$t('actionType')"
                :items="
                  items.isActionAnswer
                    ? DDActionType
                    : DDActionType.filter(
                        (e) => e.value == 'AT' || e.value == 'CA'
                      )
                "
                item-title="name"
                item-value="value"
                clearable
                v-model="items.actionType"
                @update:model-value="ChangeAction(items)"
                density="comfortable"
                hide-details="auto"
              >
                <template v-slot:item="{ props, item, index }">
                  <v-list-item
                    v-bind="props"
                    :id="'actiontype-option-' + index"
                    :value="item.raw.name"
                  >
                    <template v-slot:title>
                      <span>{{ item.raw.name }}</span>
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-card v-if="items.isParallelAction" class="card-design pa-4 mt-4 mb-4">
            <div class="parallel-action-delete">
              <div class="text-response mb-1">
                <img src="@/assets/material-icon-theme_redux-action.svg" alt="img" width="16" height="16" />
                <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('parallelAction') }}</span>
              </div>
              <button type="button" @click="DeleteParallelAction(items)">
                <img src="@/assets/Group.svg" alt="info" width="16" height="16">
              </button>
            </div>
            <div class="mt-2">
              <hr>
            </div>
            <v-row class="mb-2">
              <v-col md="6" sm="12">
                <div class="mt-4" style="gap: 2px;">
                  <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                    {{ $t('actionType') }}
                  </label>
                  <span style="color: red; margin-left: 4px;">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="16"
                        height="16"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>{{ $t('_actionTypeTooltip') }}</span>
                  </v-tooltip>
                </div>
                <v-autocomplete
                  class="validation-type-autocomplete"
                  :id="'actiontype-intentsessiondetail-' + indexs"
                  variant="outlined"
                  :placeholder="$t('actionType')"
                  :items="
                    items.isActionAnswer
                      ? DDActionType
                      : DDActionType.filter(
                          (e) => e.value == 'AT' || e.value == 'CA'
                        )
                  "
                  item-title="name"
                  item-value="value"
                  clearable
                  v-model="items.actionType"
                  @update:model-value="ChangeAction(items)"
                  density="comfortable"
                  hide-details="auto"
                >
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item 
                      v-bind="props"
                      :id="'actiontype-option-' + index" 
                      :value="item.raw.name" 
                    >
                      <template v-slot:title>
                        <span>{{ item.raw.name }}</span>
                      </template>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- Parallel Action Contact Agent Content (inside card) -->
            <v-expand-transition>
              <div v-show="items.actionType == 'CA'">
                <div class="d-flex align-center" style="gap: 2px;">
                  <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                    {{ $t('botDisableDuration') }}
                  </label>
                  <span style="color: red; margin-left: 4px;">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="16"
                        height="16"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>{{ $t('_contactAgentTooltip') }}</span>
                  </v-tooltip>
                </div>
                <div class="time-field-container mb-4">
                  <v-text-field
                    id="botDisableTime-primary-intentsessiondetail"
                    variant="outlined"
                    density="comfortable"
                    v-model="items.botDisableTime"
                    @keypress="isNumberpositive($event)"
                    :placeholder="$t('botDisableDuration')"
                    hide-details="auto"
                    class="time-input"
                    type="number"
                    min="0"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            color="grey-darken-1"
                            class="info-icon"
                            v-bind="props"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t('_botDeactivationTooltip') }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </div>
                <div class="text-response mb-1">
                  <img src="@/assets/fluent_chat-20-regular.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('textResponse') }}</span>
                </div>
                <v-textarea
                  id="prompt-contactAgent-primary-intentsessiondetail"
                  class="text-response-textarea"
                  variant="plain"
                  v-model="items.contactAgent"
                  :placeholder="$t('_writePromptForUser')"
                  hide-details="auto"
                ></v-textarea>
              </div>
            </v-expand-transition>

            <!-- Parallel Action API Trigger Content (inside card) -->
            <v-expand-transition>
              <div v-show="items.actionType == 'AT'">
                <v-row class="mb-4">
                  <v-col cols="2">
                    <div class="d-flex align-center" style="gap: 2px;">
                      <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                        {{ $t('method') }}
                      </label>
                      <span style="color: red; margin-left: 4px;">*</span>
                    </div>
                    <v-autocomplete
                      :id="'method-intentsessiondetail-' + indexs"
                      class="validation-type-autocomplete"
                      :placeholder="$t('method')"
                      ref="model"
                      item-title="name"
                      :items="DDMethod"
                      clearable
                      variant="outlined"
                      v-model="items.method"
                      density="comfortable"
                      hide-details="auto"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="d-flex align-center" style="gap: 2px;">
                      <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                        {{ $t('apiEndpoint') }}
                      </label>
                      <span style="color: red; margin-left: 4px;">*</span>
                    </div>
                    <v-text-field
                      :id="'APIendpoint-intentsessiondetail-' + indexs"
                      :placeholder="$t('apiEndpoint')"
                      v-model="items.apiEndpoint"
                      variant="outlined"
                      density="comfortable"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div class="mb-6">
                  <div class="text-response mb-1">
                    <img src="@/assets/tdesign_api.svg" alt="img" width="16" height="16" />
                    <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('headersLabel') }}</span>
                  </div>
                  <div class="mb-5 mt-3">
                    <hr>
                  </div>
                  <div
                    v-for="(header, headerIndex) in items.listHeadersAPITrigger"
                    :key="headerIndex + 'header'"
                    class="mb-3"
                  >
                    <v-row>
                      <v-col cols="5">
                        <label for="text" style="color: #171717;">{{ $t('Key') }}</label>
                        <v-text-field
                          :id="'key-intentsessiondetail-' + headerIndex"
                          :placeholder="$t('Key')"
                          v-model="header.key"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="5">
                        <label for="text" style="color: #171717;">{{ $t('valueLabel') }}</label>
                        <v-text-field
                          :id="'value-intentsessiondetail-' + headerIndex"
                          :placeholder="$t('valueLabel')"
                          v-model="header.value"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" style="display: flex; justify-content: center;">
                        <div class="action-divider"></div>
                      </v-col>
                      <v-col cols="1" class="d-flex align-center">
                        <v-btn
                          :id="'DeleteHeader-intentsessiondetail-' + headerIndex"
                          @click="DeleteHeader(items, indexs, headerIndex)"
                          icon
                          size="small"
                          variant="text"
                          color="error"
                        >
                          <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <img
                                v-bind="props"
                                src="@/assets/Group.svg"
                                alt="info"
                                width="16"
                                height="16"
                                style="cursor: pointer; margin-left: 4px;"
                              />
                            </template>
                            <span>{{ $t('delete') }}</span>
                          </v-tooltip>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                  <v-tooltip location="top" max-width="240px">
                    <template v-slot:activator="{ props }">
                      <button
                        v-bind="props"
                        :id="'AddColumn-intentsessiondetail-' + indexs"
                        @click="AddHeader(items)"
                        class="add-example-section"
                        type="button"
                      >
                        <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
                        <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">{{ $t('addHeaderBtn') }}</span>
                      </button>
                    </template>
                    <span>{{ $t('_addHeaderTooltip') }}</span>
                  </v-tooltip>
                </div>
                <div class="mb-6">
                  <div class="text-response mb-1">
                    <img src="@/assets/si_json-duotone.svg" alt="img" width="16" height="16" />
                    <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('jsonRequest') }}</span>
                  </div>
                  <div class="mb-5 mt-3">
                    <hr>
                  </div>
                  <div class="mt-4 d-flex align-center" style="gap: 2px;">
                    <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                      {{ $t('jsonModel') }}
                    </label>
                    <span style="color: red; margin-left: 4px;">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="16"
                          height="16"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('_jsonModelTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <v-row class="mb-3">
                    <v-col cols="5">
                      <v-autocomplete
                        :id="'modeljason-intentsessiondetail-' + indexs"
                        class="validation-type-autocomplete mt-2"
                        ref="model"
                        :placeholder="$t('jsonModel')"
                        :items="listDDModelDisplayName"
                        :item-title="getItemModelNameText"
                        item-value="modelDisplayID"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        v-model="items.modelDisplayRouting"
                        hide-details="auto"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <div class="json-editor-container">
                    <div class="json-variables">
                      <div class="variables-header">
                        <span class="text-subtitle-2" style="color: #171717; font-weight: 400;">{{ $t('_availableVariables') }}</span>
                      </div>
                      <div class="variables-grid">
                        <!-- Variable chips replicated -->
                        <v-tooltip location="top" max-width="310px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-transectionID-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{transactionID}')"
                              @click="insertVariable('{transactionID}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">{{ $t('transactionId') }}</span>
                            </v-chip>
                          </template>
                          <span>{{ $t('_transactionIdTooltip') }}</span>
                        </v-tooltip>
                        <v-tooltip location="top" max-width="290px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-channel-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{channel}')"
                              @click="insertVariable('{channel}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/fluent_channel-share-24-filled.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">{{ $t('channel') }}</span>
                            </v-chip>
                          </template>
                          <span>{{ $t('_channelTooltip') }}</span>
                        </v-tooltip>
                        <v-tooltip location="top" max-width="290px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-channelID-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{channelID}')"
                              @click="insertVariable('{channelID}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">{{ $t('channelId') }}</span>
                            </v-chip>
                          </template>
                          <span>{{ $t('_channelIdTooltip') }}</span>
                        </v-tooltip>
                        <v-tooltip location="top" max-width="290px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-userchannel-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{userChannel}')"
                              @click="insertVariable('{userChannel}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/fluent_channel-share-24-filled.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">{{ $t('userChannel') }}</span>
                            </v-chip>
                          </template>
                          <span>{{ $t('_channelTooltip') }}</span>
                        </v-tooltip>
                        <v-tooltip location="top" max-width="330px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-sessionID-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{sessionID}')"
                              @click="insertVariable('{sessionID}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">{{ $t('sessionId') }}</span>
                            </v-chip>
                          </template>
                          <span>{{ $t('_sessionIdTooltip') }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                    <prism-editor
                      :id="'codeEditor-' + indexs"
                      class="modern-editor"
                      v-model="items.jsonValidate"
                      :highlight="highlighter"
                      @drop="onDrop($event)"
                      @dragover="onDragOver($event)"
                      @dragleave="onDragLeave($event)"
                      :line-numbers="true"
                      :autoStyleLineNumbers="true"
                      :ignoreTabKey="true"
                    ></prism-editor>
                  </div>
                </div>
                <div class="mb-6">
                  <div class="text-response mb-1">
                    <img src="@/assets/hugeicons_password-validation.svg" alt="img" width="16" height="16" />
                    <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('Validation') }}</span>
                  </div>
                  <div class="mb-5 mt-3">
                    <hr>
                  </div>
                  <div
                    v-for="(valid, indexValid) in items.listValidation"
                    :key="indexValid + 'Validate'"
                    class="mb-4"
                  >
                    <v-row>
                      <v-col cols="12" md="11">
                        <v-card class="validation-item-card" flat>
                          <div class="d-flex justify-space-between align-start flex-wrap" style="gap:16px;">
                            <div class="validation-fields d-flex flex-wrap" style="flex:1; gap:16px;">
                              <div class="validation-field" style="min-width:220px; flex:1;">
                                <div class="validation-label">{{ $t('Key') }}</div>
                                <v-text-field
                                  :placeholder="$t('Key')"
                                  v-model="valid.key"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                ></v-text-field>
                              </div>
                              <div class="validation-field" style="min-width:240px; flex:1;">
                                <div class="d-flex align-center" style="gap:2px;">
                                  <div class="validation-label">{{ $t('validationType') }}</div>
                                  <span style="color:red; margin-left:4px;">*</span>
                                </div>
                                <v-autocomplete
                                  class="validation-type-autocomplete"
                                  ref="model"
                                  :placeholder="$t('validationType')"
                                  :items="DDTypeValidation"
                                  item-title="name"
                                  item-value="value"
                                  clearable
                                  variant="outlined"
                                  v-model="valid.typeValidation"
                                  density="comfortable"
                                  hide-details
                                ></v-autocomplete>
                              </div>
                              <div
                                class="validation-field"
                                v-if="valid.typeValidation == 'MCV'"
                                style="min-width:200px; flex:1;"
                              >
                                <div class="validation-label">{{ $t('maximumCharacters') }}</div>
                                <v-text-field
                                  :id="'NumberOfCharacter-intentsessiondetail' + indexs"
                                  :placeholder="$t('_enterMaximumCharacters')"
                                  v-model="valid.numberOfCharacter"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                ></v-text-field>
                              </div>
                              <div
                                class="validation-field"
                                v-if="valid.typeValidation == 'RV'"
                                style="min-width:240px; flex:1;"
                              >
                                <div class="validation-label">{{ $t('regularExpression') }}</div>
                                <v-text-field
                                  :id="'ValidationRegularExpression-intentsessiondetail' + indexs"
                                  :placeholder="$t('regularExpression')"
                                  v-model="valid.regExp"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                ></v-text-field>
                              </div>
                            </div>
                          </div>
                          <div class="validation-message mt-4">
                            <v-textarea
                              variant="outlined"
                              v-model="valid.promptMessage"
                              :placeholder="$t('errorMessage')"
                              hide-details="auto"
                            ></v-textarea>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="1">
                        <div class="validation-actions" style="align-self:flex-start;">
                          <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                v-bind="props"
                                :id="'DeleteValidation-intentsessiondetail' + indexs"
                                @click="DeleteValidation(items, indexs, indexValid)"
                                icon
                                size="small"
                                variant="text"
                                color="error"
                              >
                                <img src="@/assets/Group.svg" alt="delete" width="16" height="16" />
                              </v-btn>
                            </template>
                            <span>{{ $t('delete') }}</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                  <v-tooltip location="top" max-width="260px">
                    <template v-slot:activator="{ props }">
                      <button
                        v-bind="props"
                        :id="'AddColumn-intentsessiondetail-' + indexs"
                        @click="AddValidation(items)"
                        class="add-example-section"
                        type="button"
                      >
                        <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
                        <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">{{ $t('addValidation') }}</span>
                      </button>
                    </template>
                    <span>{{ $t('_addValidationTooltip') }}</span>
                  </v-tooltip>
                </div>
                <div class="mb-4">
                  <div class="text-response mb-1">
                    <img src="@/assets/fluent_chat-20-regular.svg" alt="img" width="16" height="16" />
                    <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('textResponse') }}</span>
                  </div>
                  <v-textarea
                    variant="outlined"
                    v-model="items.textResponse"
                    :placeholder="$t('_writePromptForUser')"
                    hide-details="auto"
                  ></v-textarea>
                </div>
              </div>
            </v-expand-transition>
          </v-card>


          <!-- Vector Type Content -->
          <v-expand-transition>
            <div v-show="items.actionType == 'VT'">
              <v-row class="mb-4">
                <v-col cols="6">
                  <div style="gap: 2px;">
                    <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                      {{ $t('documentName') }}
                    </label>
                    <span style="color: red; margin-left: 4px;">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="16"
                          height="16"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('_actionTypeTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    :id="'vectorname-intentsessiondetail-' + indexs"
                    class="validation-type-autocomplete"
                    :placeholder="$t('documentName')"
                    :items="DDVector"
                    item-title="name"
                    item-value="name"
                    clearable
                    variant="outlined"
                    v-model="VectorName"
                    @update:model-value="GetByVector()"
                    density="comfortable"
                    hide-details="auto"s
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'vectorname-option-' + index" 
                        :value="item.raw.name" 
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-data-table
                v-show="ShowTable"
                :items-per-page="itemsPerPage"
                :server-items-length="searchTotalTable"
                v-model:options="options"
                :items="dataTable"
                :headers="headers"
                :loading="loadingTable"
                :loading-text="$t('loading')"
                fixed-header
                class="elevation-1 vector-table mb-4"
                density="comfortable"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="text-align: left">
                      <v-checkbox
                        :id="
                          'selectvector-intentsessiondetail-' + indexs
                        "
                        v-model="item.selected"
                        @change="
                          SelectVector(
                            items,
                            item.selected,
                            item.id,
                            item.textORG
                          )
                        "
                        hide-details
                        density="compact"
                        color="#C32E0E"
                      ></v-checkbox>
                    </td>
                    <td style="text-align: left">
                      <div class="text-container">
                        <span
                          :class="[
                            item.show
                              ? 'text-content-show'
                              : 'text-content',
                          ]"
                          v-html="formatText(item.textORG)"
                        ></span>
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div class="text-container">
                        <span
                          :class="[
                            item.show
                              ? 'text-content-show'
                              : 'text-content',
                          ]"
                          v-html="formatText(item.textEN)"
                        ></span>
                        <v-btn
                          :id="
                            'itemshow-intentsessiondetail-' + indexs
                          "
                          @click="item.show = !item.show"
                          icon
                          size="small"
                          variant="text"
                          class="ml-2"
                          color="#C32E0E"
                        >
                          <v-icon>{{
                            item.show
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                          }}</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <div class="selected-vectors mb-4 mt-4 pa-2" v-if="items.vectorDetail && items.vectorDetail.length > 0">
                <div class="mb-2">
                  <span class="text-subtitle-2 font-weight-medium"
                    >{{ $t('selectedChunks') }}</span
                  >
                </div>
                <div class="d-flex flex-wrap" style="gap: 8px;">
                  <v-chip
                    v-for="(item3, vectorIndex) in items.vectorDetail"
                    :key="vectorIndex + '_TextORG'"
                    closable
                    color="grey"
                    variant="elevated"
                    size="small"
                    class="selected-chunks-design d-flex align-center"
                    @click:close="DeleteVectorByBtn(items, item3.tblVector)"
                  >
                    <span class="chip-text-design">{{ item3.textORG }}</span>
                    <button
                      type="button"
                      class="d-flex align-center ml-2"
                      @click.stop="DeleteVectorByBtn(items, item3.tblVector)"
                    >
                      <img src="@/assets/Frame 1000009610.svg" alt="icon" width="20" height="20" />
                    </button>
                  </v-chip>
                </div>
              </div>


              <v-textarea
                :id="'textarea-prompt-intentsessiondetail-' + indexs"
                class="text-response-textarea"
                variant="plain"
                v-model="items.prompt"
                :placeholder="$t('_enterAPrompt')"
                hide-details="auto"
              ></v-textarea>
            </div>
          </v-expand-transition>

          <!-- Text Response Content -->
          <v-expand-transition>
            <div v-show="items.actionType == 'TR'">
              <v-textarea
                :id="'textarea-message-intentsessiondetail-' + indexs"
                class="text-response-textarea"
                variant="plain"
                v-model="items.textResponse"
                :placeholder="$t('_writePromptForUser')"
                hide-details="auto"
              ></v-textarea>
            </div>
          </v-expand-transition>

          <!-- Model Routing Content -->
          <v-expand-transition>
            <div v-show="items.actionType == 'MR'">
              <div class="d-flex align-center" style="gap: 2px;">
                <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                  {{ $t('modelRouting') }}
                </label>
                <span style="color: red; margin-left: 4px;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="16"
                      height="16"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>{{ $t('_modelRoutingTooltip') }}</span>
                </v-tooltip>
              </div>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    id="choose-model-modelrouting-intentsessiondetail"
                    class="validation-type-autocomplete"
                    ref="model"
                    :placeholder="$t('modelRouting')"
                    :items="listDDModelDisplayName"
                    :item-title="getItemModelNameText"
                    item-value="modelDisplayID"
                    clearable
                    variant="outlined"
                    v-model="items.modelDisplayRouting"
                    density="comfortable"
                    hide-details="auto"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'nextrouting-option-' + index" 
                        :value="item.raw.name" 
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>

          <!-- Next Routing Content -->
          <v-expand-transition>
            <div v-show="items.actionType == 'NR'">
              <div class="d-flex align-center" style="gap: 2px;">
                <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                  {{ $t('nextRouting') }}
                </label>
                <span style="color: red; margin-left: 4px;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="16"
                      height="16"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>{{ $t('_nextRoutingTooltip') }}</span>
                </v-tooltip>
              </div>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :id="'nextrouting-intentsessiondetail-' + indexs"
                    class="validation-type-autocomplete"
                    ref="model"
                    :placeholder="$t('nextRouting')"
                    :items="listDDIntentGroup"
                    item-title="name"
                    item-value="id"
                    clearable
                    variant="outlined"
                    v-model="items.nextRouting"
                    density="comfortable"
                    hide-details="auto"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'nextrouting-options-' + index" 
                        :value="item.raw.name" 
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>

          <!-- Contact Agent Content (non-parallel only) -->
          <v-expand-transition v-if="!items.isParallelAction">
            <div v-show="items.actionType == 'CA'">
              <div class="d-flex align-center" style="gap: 2px;">
                <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                  {{ $t('botDisableDuration') }}
                </label>
                <span style="color: red; margin-left: 4px;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="16"
                      height="16"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>{{ $t('_contactAgentTooltip') }}</span>
                </v-tooltip>
              </div>
              <!-- Bot Disable Time Field -->
              <div class="time-field-container mb-4">
                <v-text-field
                  id="botDisableTime-secondary-intentsessiondetail"
                  variant="outlined"
                  density="comfortable"
                  v-model="items.botDisableTime"
                  @keypress="isNumberpositive($event)"
                  :placeholder="$t('botDisableDuration')"
                  hide-details="auto"
                  class="time-input"
                  type="number"
                  min="0"
                >
                  <template v-slot:append-outer>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="small"
                          color="grey-darken-1"
                          class="info-icon"
                          v-bind="props"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t('_botDeactivationTooltip') }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </div>

              <!-- Contact Agent Message -->
              <div class="text-response mb-1">
                <img src="@/assets/fluent_chat-20-regular.svg" alt="img" width="16" height="16" />
                <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('textResponse') }}</span>
              </div>
              <v-textarea
                id="prompt-contactAgent-secondary-intentsessiondetail"
                class="text-response-textarea"
                variant="plain"
                v-model="items.contactAgent"
                :placeholder="$t('_writePromptForUser')"
                hide-details="auto"
              ></v-textarea>
            </div>
          </v-expand-transition>

          <!-- API Trigger Content (non-parallel only) -->
          <v-expand-transition v-if="!items.isParallelAction">
            <div v-show="items.actionType == 'AT'">
              <!-- API Method and Endpoint -->
              <v-row class="mb-4">
                <v-col cols="2">
                  <div class="d-flex align-center" style="gap: 2px;">
                    <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                      {{ $t('method') }}
                    </label>
                    <span style="color: red; margin-left: 4px;">*</span>
                  </div>
                  <v-autocomplete
                    :id="'method-intentsessiondetail-' + indexs"
                    class="validation-type-autocomplete"
                    :placeholder="$t('method')"
                    ref="model"
                    item-title="name"
                    :items="DDMethod"
                    clearable
                    variant="outlined"
                    v-model="items.method"
                    density="comfortable"
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center" style="gap: 2px;">
                    <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                      {{ $t('apiEndpoint') }}
                    </label>
                    <span style="color: red; margin-left: 4px;">*</span>
                  </div>
                  <v-text-field
                    :id="'APIendpoint-intentsessiondetail-' + indexs"
                    :placeholder="$t('apiEndpoint')"
                    v-model="items.apiEndpoint"
                    variant="outlined"
                    density="comfortable"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Headers Section -->
              <div class="mb-6">
                <div class="text-response mb-1">
                  <img src="@/assets/tdesign_api.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('headersLabel') }}</span>
                </div>
                <div class="mb-5 mt-3">
                  <hr>
                </div>
                <div
                  v-for="(
                    header, headerIndex
                  ) in items.listHeadersAPITrigger"
                  :key="headerIndex + 'header'"
                  class="mb-3"
                >
                  <v-row>
                    <v-col cols="5">
                      <label for="text" style="color: #171717;">{{ $t('Key') }}</label>
                      <v-text-field
                        :id="'key-intentsessiondetail-' + headerIndex"
                        :placeholder="$t('Key')"
                        v-model="header.key"
                        variant="outlined"
                        density="comfortable"
                        hide-details
                        color="primary"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="5">
                      <label for="text" style="color: #171717;">{{ $t('valueLabel') }}</label>
                      <v-text-field
                        :id="
                          'value-intentsessiondetail-' + headerIndex
                        "
                        :placeholder="$t('valueLabel')"
                        v-model="header.value"
                        variant="outlined"
                        density="comfortable"
                        hide-details
                        color="primary"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1" style="display: flex; justify-content: center;">
                      <div class="action-divider"></div>
                    </v-col>
                    <v-col cols="1" class="d-flex align-center">
                      <v-btn
                        :id="
                          'DeleteHeader-intentsessiondetail-' +
                          headerIndex
                        "
                        @click="
                          DeleteHeader(items, indexs, headerIndex)
                        "
                        icon
                        size="small"
                        variant="text"
                        color="error"
                      >
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <img
                              v-bind="props"
                              src="@/assets/Group.svg"
                              alt="info"
                              width="16"
                              height="16"
                              style="cursor: pointer; margin-left: 4px;"
                            />
                          </template>
                          <span>{{ $t('delete') }}</span>
                        </v-tooltip>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>

                <v-tooltip location="top" max-width="240px">
                  <template v-slot:activator="{ props }">
                    <button
                      v-bind="props"
                      :id="'AddColumn-intentsessiondetail-' + indexs"
                      @click="AddHeader(items)"
                      class="add-example-section"
                      type="button"
                    >
                      <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
                      <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">{{ $t('addHeaderBtn') }}</span>
                    </button>
                  </template>
                  <span>{{ $t('_addHeaderTooltip') }}</span>
                </v-tooltip>
              </div>

              <!-- JSON Request Section -->
              <div class="mb-6">
                <div class="text-response mb-1">
                  <img src="@/assets/si_json-duotone.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('jsonRequest') }}</span>
                </div>
                <div class="mb-5 mt-3">
                  <hr>
                </div>
                <div class="mt-4 d-flex align-center" style="gap: 2px;">
                  <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                    {{ $t('jsonModel') }}
                  </label>
                  <span style="color: red; margin-left: 4px;">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="16"
                        height="16"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>{{ $t('_jsonModelTooltip') }}</span>
                  </v-tooltip>
                </div>

                <v-row class="mb-3">
                  <v-col cols="5">
                    <v-autocomplete
                      :id="'modeljason-intentsessiondetail-' + indexs"
                      class="validation-type-autocomplete mt-2"
                      ref="model"
                      :placeholder="$t('jsonModel')"
                      :items="listDDModelDisplayName"
                      :item-title="getItemModelNameText"
                      item-value="modelDisplayID"
                      clearable
                      variant="outlined"
                      density="comfortable"
                      v-model="items.modelDisplayRouting"
                      hide-details="auto"
                      color="primary"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <div class="json-editor-container">
                  <div class="json-variables">
                    <div class="variables-header">
                      <span class="text-subtitle-2" style="color: #171717; font-weight: 400;">{{ $t('_availableVariables') }}</span>
                    </div>
                    <div class="variables-grid">
                      <v-tooltip location="top" max-width="310px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-transectionID-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="
                              onDragStart($event, '{transactionID}')
                            "
                            @click="
                              insertVariable('{transactionID}', indexs)
                            "
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">{{ $t('transactionId') }}</span>
                          </v-chip>
                        </template>
                        <span>{{ $t('_transactionIdTooltip') }}</span>
                      </v-tooltip>
                      
                      <v-tooltip location="top" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-channel-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="onDragStart($event, '{channel}')"
                            @click="insertVariable('{channel}', indexs)"
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/fluent_channel-share-24-filled.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">{{ $t('channel') }}</span>
                          </v-chip>
                        </template>
                        <span>{{ $t('_channelTooltip') }}</span>
                      </v-tooltip>

                      <v-tooltip location="top" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-channelID-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="
                              onDragStart($event, '{channelID}')
                            "
                            @click="insertVariable('{channelID}', indexs)"
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">{{ $t('channelId') }}</span>
                          </v-chip>
                        </template>
                        <span>{{ $t('_channelIdTooltip') }}</span>
                      </v-tooltip>

                      <v-tooltip location="top" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-userchannel-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="
                              onDragStart($event, '{userChannel}')
                            "
                            @click="
                              insertVariable('{userChannel}', indexs)
                            "
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/fluent_channel-share-24-filled.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">{{ $t('userChannel') }}</span>
                          </v-chip>
                        </template>
                        <span>{{ $t('_channelTooltip') }}</span>
                      </v-tooltip>

                      <v-tooltip location="top" max-width="330px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-sessionID-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="
                              onDragStart($event, '{sessionID}')
                            "
                            @click="insertVariable('{sessionID}', indexs)"
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">{{ $t('sessionId') }}</span>
                          </v-chip>
                        </template>
                        <span>{{ $t('_sessionIdTooltip') }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                  <prism-editor
                    :id="'codeEditor-' + indexs"
                    class="modern-editor"
                    v-model="items.jsonValidate"
                    :highlight="highlighter"
                    @drop="onDrop($event)"
                    @dragover="onDragOver($event)"
                    @dragleave="onDragLeave($event)"
                    :line-numbers="true"
                    :autoStyleLineNumbers="true"
                    :ignoreTabKey="true"
                  ></prism-editor>
                </div>
              </div>

              <!-- Validation Section -->
              <div class="mb-6">
                <div class="text-response mb-1">
                  <img src="@/assets/hugeicons_password-validation.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('Validation') }}</span>
                </div>
                <div class="mb-5 mt-3">
                  <hr>
                </div>

                <div
                  v-for="(valid, indexValid) in items.listValidation"
                  :key="indexValid + 'Validate'"
                  class="mb-4"
                >
                  <v-row>
                    <v-col cols="12" md="11">
                      <v-card class="validation-item-card" flat>
                        <div class="d-flex justify-space-between align-start flex-wrap" style="gap:16px;">
                          <div class="validation-fields d-flex flex-wrap" style="flex:1; gap:16px;">
                            <div class="validation-field" style="min-width:220px; flex:1;">
                              <div class="validation-label">{{ $t('Key') }}</div>
                              <v-text-field
                                :placeholder="$t('Key')"
                                v-model="valid.key"
                                variant="outlined"
                                density="comfortable"
                                hide-details
                              ></v-text-field>
                            </div>
                            <div class="validation-field" style="min-width:240px; flex:1;">
                              <div class="d-flex align-center" style="gap:2px;">
                                <div class="validation-label">{{ $t('validationType') }}</div>
                                <span style="color:red; margin-left:4px;">*</span>
                              </div>
                              <v-autocomplete
                                class="validation-type-autocomplete"
                                ref="model"
                                :placeholder="$t('validationType')"
                                :items="DDTypeValidation"
                                item-title="name"
                                item-value="value"
                                clearable
                                variant="outlined"
                                v-model="valid.typeValidation"
                                density="comfortable"
                                hide-details
                              ></v-autocomplete>
                            </div>
                            <div
                              class="validation-field"
                              v-if="valid.typeValidation == 'MCV'"
                              style="min-width:200px; flex:1;"
                            >
                              <div class="validation-label">{{ $t('maximumCharacters') }}</div>
                              <v-text-field
                                :id="'NumberOfCharacter-intentsessiondetail' + indexs"
                                :placeholder="$t('_enterMaximumCharacters')"
                                v-model="valid.numberOfCharacter"
                                variant="outlined"
                                density="comfortable"
                                hide-details
                              ></v-text-field>
                            </div>
    
                            <div
                              class="validation-field"
                              v-if="valid.typeValidation == 'RV'"
                              style="min-width:240px; flex:1;"
                            >
                              <div class="validation-label">{{ $t('regularExpression') }}</div>
                              <v-text-field
                                :id="'ValidationRegularExpression-intentsessiondetail' + indexs"
                                :placeholder="$t('regularExpression')"
                                v-model="valid.regExp"
                                variant="outlined"
                                density="comfortable"
                                hide-details
                              ></v-text-field>
                            </div>
                          </div>
                        </div>
    
                        <div class="validation-message mt-4">
                          <v-textarea
                            variant="outlined"
                            v-model="valid.promptMessage"
                            :placeholder="$t('errorMessage')"
                            hide-details="auto"
                          ></v-textarea>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="1">
                      <div class="validation-actions" style="align-self:flex-start;">
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              v-bind="props"
                                :id="'DeleteValidation-intentsessiondetail' + indexs"
                                @click="DeleteValidation(items, indexs, indexValid)"
                                icon
                                size="small"
                                variant="text"
                                color="error"
                            >
                              <img src="@/assets/Group.svg" alt="delete" width="16" height="16" />
                            </v-btn>
                          </template>
                          <span>{{ $t('delete') }}</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <v-tooltip location="top" max-width="260px">
                  <template v-slot:activator="{ props }">
                    <button
                      v-bind="props"
                      :id="'AddColumn-intentsessiondetail-' + indexs"
                      @click="AddValidation(items)"
                      class="add-example-section"
                      type="button"
                    >
                      <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
                      <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">{{ $t('addValidation') }}</span>
                    </button>
                  </template>
                  <span>{{ $t('_addValidationTooltip') }}</span>
                </v-tooltip>

              </div>

              <!-- Text Response Section for API -->
              <div class="mb-4">
                <div class="text-response mb-1">
                  <img src="@/assets/fluent_chat-20-regular.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">{{ $t('textResponse') }}</span>
                </div>
                <v-textarea
                  variant="outlined"
                  v-model="items.textResponse"
                  :placeholder="$t('_writePromptForUser')"
                  hide-details="auto"
                ></v-textarea>
              </div>
            </div>
          </v-expand-transition>
        </div>
        
        <div class="intent-action-btn-wrapper">
          <v-tooltip location="top" max-width="260px">
            <template v-slot:activator="{ props }">
              <button
                type="button"
                v-bind="props"
                :id="'AddNewAction-intentsessiondetail'"
                @click="AddNewAction()"
                variant="outlined"
                size="large"
                block
                class="intent-action-btn"
              >
                <img src="@/assets/ic_round-plus.svg" alt="img" width="16" height="16" />
                <span class="intent-text">{{ $t('addParallelAction') }}</span>
              </button>
            </template>
            <span style="font-size: 14px;">{{ $t('_addParallelActionTooltip') }}</span>
          </v-tooltip>
        </div>
      </v-card>
      
      <div class="mt-6">
        <hr>
      </div>
      
      <v-row class="mt-2 gap-6">
        <v-col cols="12" class="d-flex justify-end">
          <div style="display: flex; gap: 12px;">
            <button class="add-example-section"
              :id="'button-close-intentsessiondetail'"
              @click="Back()" >
              <img src="@/assets/line-md_close.svg" alt="img" width="12" height="12" />
              <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">{{ $t('close') }}</span>
            </button>

            <button
              class="btn-action-design"
              v-if="AddEvent"
              :id="'button-saveadd-intentsessiondetail'"
              @click="SaveAdd()"
              >
              <img src="@/assets/mage_save-btn.svg" alt="img" width="20" height="20" />
              <span style="color: #ffffff; font-size: 14px;">{{ $t('save') }}</span>
            </button>
            <button
              class="btn-action-design"
              v-else
              :id="'button-saveedit-intentsessiondetail'"
                @click="SaveEdit()"
            >
              <img src="@/assets/mage_save-floppy.svg" alt="img" width="20" height="20" />
              <span style="color: #ffffff; font-size: 14px;">{{ $t('save') }}</span>
            </button>
          </div>
        </v-col>
      </v-row>

    </v-container>

    <!-- Loading Dialog -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Clipboard Popup -->
    <v-snackbar
      v-model="showClipboardPopup"
      timeout="2000"
      color="success"
      location="bottom left"
    >
      <v-icon start>mdi-check</v-icon>
      {{ $t('_copiedToClipboard') }}
    </v-snackbar>

    <!-- Name Required Dialog -->
    <v-dialog v-model="showNameRequiredDialog" max-width="460" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">{{ $t('_intentSessionNameRequired') }}</h3>
          <button type="button" @click="showNameRequiredDialog = false" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">{{ $t('_fillAllRequiredInfo') }}</p>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <v-btn class="ok-required-btn" @click="showNameRequiredDialog = false" :id="'button-requiredname-ok'">{{ $t('ok') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Confirm Upload -->
    <v-dialog v-model="showConfirmDialog" max-width="570" class="dialog-upload-card">
      <v-card class="confirm-dialog-card">
        <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
          <span class="dialog-title font-weight-bold">{{ $t('importExampleQuestionText') }}</span>
          <v-btn icon variant="text" density="comfortable" @click="showConfirmDialog = false">
            <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6 pb-4 px-4 body-text">
          {{ $t('_confirmImportExampleQuestion') }}
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
          <button type="button" class="cancel-btn" @click="showConfirmDialog = false" :disabled="deleting">{{ $t('cancel') }}</button>
          <button type="button" class="confirm-btn" @click="ConfirmProcess">
            <span style="color: #ffffff; font-size: 13px; letter-spacing: 1px;">{{ $t('confirm') }}</span>
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles
import { highlight, languages } from "prismjs";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-rust";
import DragDropFile from "@/components/DragDropFile.vue";
import iconGoalsColor from '@/assets/mage_goals-fill.svg';
import iconGoalsWhite from '@/assets/mage_goals-fill-white.svg';
import iconActionOpen from '@/assets/material-symbols_action-key-white.svg';
import iconActionClose from '@/assets/material-symbols_action-key.svg';
import expandTop from '@/assets/expand-top.svg';
import expandDown from '@/assets/Expand.svg';
import ExcelJS from "exceljs";

import "prismjs/plugins/line-numbers/prism-line-numbers.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
export default {
  name: "IntentSessionDetail",
  inject: ["flagNav"],
  components: { PrismEditor, DragDropFile },
  mixins: [checkPermissionTwo],
  data() {
    return {
    showConfirmDialog: false,
    showSuccess: false,
    successMessage: '',
    _toastTimer: null,
    showDialog: false,
    showActionDialog: false,
    showNameRequiredDialog: false,
    options: {},
    dataTable: [],
    VectorDetail: [],
    Selected: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    listDDModelDisplayName: [],
    listDDIntentGroup: [],
    Search: "",
    CodeEx: '{\n   "A":""\n}',
    id: null,
    panel: [0, 1],
    dialog: false,
    loadingTable: false,
    AddEvent: false,
    ShowTable: false,
    today: null,
    loading: true,
    DataCol: [],
    type: null,
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    showClipboardPopup: false,
    rules: {
      required: (value) => !!value || this.$t("Required"),
    },
    Intent: [{ text: "What was that?" }, { text: "" }],
    VectorName: "",
    Vectors: "",
    Request: {
      IntentGroupID: 0,
      IntentSessionID: 0,
      IntentActionID: 0,
      Score: "",
      Name: "",
      UseMemory: false,
      PromptSession:
        "Find the Intent from the message of users.\n#Condition for Response\n1. If the user asks a question related to or similar in meaning to the #Group Intent below. You must response 1. Otherwise, 0\n#Group Intent\n",
      ActionType: "",
      TBLVector: "",
      Intent: "",
      Prompt: "",
      IntentActions: [],
    },
    RequestIntentAction: {
      intentActionID: 0,
      tblVector: "",
      prompt: "",
      textResponse: "",
      method: "",
      apiEndpoint: "",
      listHeadersAPITrigger: [
        {
          key: "",
          value: "",
        },
      ],
      jsonValidate: '{\n   "A":""\n}',
      modelDisplayRouting: null,
      listValidation: [
        {
          key: "",
          typeValidation: "",
          numberOfCharacter: "",
          regExp: "",
          promptMessage: "",
        },
      ],
      nextRouting: null,
      isMergePrompt: true,
      actionType: "",
      isActionAnswer: false,
      activeFlag: true,
      botDisableTime: null,
    },
    DataRowUpload: [],
    DDMethod: ["GET", "POST", "PUT", "DELETE"],
    DDVector: [],
    uploadedFiles: [],
    entity: null,
    iconGoalsColor,
    iconGoalsWhite,
    iconActionOpen,
    iconActionClose,
    expandTop,
    expandDown,
    };
  },
  computed: {
    headers() {
      return [];
    },
    DDActionType() {
      return [
        { name: this.$t("ddDocument"), value: "VT" },
        { name: this.$t("textResponse"), value: "TR" },
        { name: this.$t("modelRouting"), value: "MR" },
        { name: this.$t("nextRouting"), value: "NR" },
        { name: this.$t("ddContactAgent"), value: "CA" },
        { name: this.$t("ddApiTrigger"), value: "AT" },
      ];
    },
    DDTypeValidation() {
      return [
        { name: this.$t("ddValidationPhone"), value: "PV" },
        { name: this.$t("ddValidationEmail"), value: "EV" },
        { name: this.$t("ddValidationMaxChar"), value: "MCV" },
        { name: this.$t("ddValidationRegex"), value: "RV" },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.GetByVector();
      },
      deep: true,
    },
  },
  methods: {
    showPopup() {
      this.showClipboardPopup = true;
      setTimeout(() => {
        this.showClipboardPopup = false;
      }, 2000);
    },
    CopyText(text) {
      navigator.clipboard.writeText(text);
      this.showPopup();
    },

    onDragStart(event, text) {
      event.dataTransfer.setData("text/plain", text);
      event.dataTransfer.effectAllowed = "copy";
    },

    onDragOver(event) {
      event.dataTransfer.dropEffect = "copy";

      // เพิ่ม visual feedback
      const editor = event.target.closest(".prism-editor-wrapper");
      if (editor) {
        editor.classList.add("drag-over");
      }
    },

    onDragLeave(event) {
      // เอา visual feedback ออก
      const editor = event.target.closest(".prism-editor-wrapper");
      if (editor) {
        editor.classList.remove("drag-over");
      }
    },

    _getDropPosition(event, textarea) {
      const rect = textarea.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      let position = 0;
      if (document.caretPositionFromPoint) {
        const caretPos = document.caretPositionFromPoint(event.clientX, event.clientY);
        if (caretPos && caretPos.offsetNode === textarea) {
          position = caretPos.offset;
        }
      } else if (document.caretRangeFromPoint) {
        const range = document.caretRangeFromPoint(event.clientX, event.clientY);
        if (range && range.startContainer === textarea) {
          position = range.startOffset;
        }
      } else {
        // Fallback: คำนวณตำแหน่งโดยประมาณ
        const lines = textarea.value.split("\n");
        const lineHeight = Number.parseInt(getComputedStyle(textarea).lineHeight) || 20;
        const charWidth = 8; // ความกว้างโดยประมาณของตัวอักษร
        const lineIndex = Math.floor(y / lineHeight);
        const charIndex = Math.floor(x / charWidth);
        if (lineIndex < lines.length) {
          position = lines.slice(0, lineIndex).join("\n").length;
          if (lineIndex > 0) position += 1; // เพิ่ม newline
          position += Math.min(charIndex, lines[lineIndex]?.length || 0);
        } else {
          position = textarea.value.length;
        }
      }
      return position;
    },
    onDrop(event) {
      event.preventDefault();
      const text = event.dataTransfer.getData("text/plain");

      // หา prism-editor element
      const editor = event.target.closest(".prism-editor-wrapper");
      const textarea = editor?.querySelector("textarea");

      if (textarea) {
        // เอา visual feedback ออก
        editor.classList.remove("drag-over");

        // หาตำแหน่งใน textarea จากพิกัด mouse
        const position = this._getDropPosition(event, textarea);

        // แทรกข้อความที่ตำแหน่งที่คำนวณได้
        const currentValue = textarea.value;
        const newValue =
          currentValue.substring(0, position) +
          text +
          currentValue.substring(position);

        // หา action item ที่ตรงกัน และอัพเดต
        const editorId = editor.closest('[id^="codeEditor"]')?.id;
        if (editorId) {
          const indexMatch = editorId.match(/codeEditor-(\d+)/);
          if (indexMatch) {
            const actionIndex = Number.parseInt(indexMatch[1]);
            const actions = this.Request.IntentActions.filter(
              (e) => e.activeFlag === true
            );
            if (actions[actionIndex]) {
              actions[actionIndex].jsonValidate = newValue;

              // ตั้งตำแหน่ง cursor หลังข้อความที่แทรก
              this.$nextTick(() => {
                const newPosition = position + text.length;
                textarea.setSelectionRange(newPosition, newPosition);
                textarea.focus();
              });
            }
          }
        }
      }
    },

    // ปรับปรุง insertVariable method
    insertVariable(text, indexs) {
      const editorId = `codeEditor-${indexs}`;
      const editor = document.getElementById(editorId);
      const textarea = editor?.querySelector("textarea");

      if (textarea) {
        const start = textarea.selectionStart || 0;
        const end = textarea.selectionEnd || 0;
        const currentValue = textarea.value;

        const newValue =
          currentValue.substring(0, start) + text + currentValue.substring(end);

        // อัพเดต model
        const actions = this.Request.IntentActions.filter(
          (e) => e.activeFlag === true
        );
        if (actions[indexs]) {
          actions[indexs].jsonValidate = newValue;
        }

        // ตั้งตำแหน่ง cursor
        this.$nextTick(() => {
          textarea.setSelectionRange(start + text.length, start + text.length);
          textarea.focus();
        });
      }
    },
    toggleAllMergePrompt() {
      // Set isMergePrompt for all IntentActions based on UseBasePrompt switch
      this.Request.IntentActions.forEach(action => {
        action.isMergePrompt = this.Request.UseBasePrompt;
      });
    },
    ChangeAction(IntentAction) {
      IntentAction.tblVector = "";
      IntentAction.prompt = "";
      IntentAction.textResponse = "";
      IntentAction.method = "";
      IntentAction.apiEndpoint = "";
      IntentAction.listHeadersAPITrigger = [
        {
          key: "",
          value: "",
        },
      ];
      IntentAction.listValidation = [
        {
          key: "",
          typeValidation: "",
          numberOfCharacter: "",
          regExp: "",
          promptMessage: "",
        },
      ];
      IntentAction.jsonValidate = '{\n   "A":""\n}';
      IntentAction.modelDisplayRouting = null;
      IntentAction.nextRouting = null;
      IntentAction.isMergePrompt = this.Request.UseBasePrompt;
      IntentAction.botDisableTime = "";
    },
    AddNewAction() {
      this.Request.IntentActions.push({
        intentActionID: "",
        tblVector: "",
        prompt: "",
        textResponse: "",
        method: "",
        apiEndpoint: "",
        listHeadersAPITrigger: [
          {
            key: "",
            value: "",
          },
        ],
        listValidation: [
          {
            key: "",
            typeValidation: "",
            numberOfCharacter: "",
            regExp: "",
            promptMessage: "",
          },
        ],
        jsonValidate: '{\n   "A":""\n}',
        modelDisplayRouting: null,
        nextRouting: null,
        isMergePrompt: this.Request.UseBasePrompt,
        actionType: "",
        isActionAnswer: this.Request.IntentActions.length == 0,
        activeFlag: true,
        vectorDetail: [],
        contactAgent: "",
        botDisableTime: "",
        // Show Parallel Action card only for actions added after the first one
        isParallelAction: this.Request.IntentActions.length > 0,
      });
    },
    AddHeader(item) {
      item.listHeadersAPITrigger.push({
        key: "",
        value: "",
      });
    },
    AddValidation(item) {
      item.listValidation.push({
        key: "",
        typeValidation: "",
        numberOfCharacter: "",
        regExp: "",
        promptMessage: "",
      });
    },
    DeleteAction(item, index) {
      item.activeFlag = false;
      if (item.intentActionID == 0) {
        this.Request.IntentActions.splice(index, 1);
      }
    },
    DeleteHeader(item, index, indexHeader) {
      if (item.listHeadersAPITrigger.length > 0) {
        this.Request.IntentActions[index].listHeadersAPITrigger.splice(
          indexHeader,
          1
        );
      }
    },
    DeleteValidation(item, index, indexValidation) {
      if (item.listValidation.length > 0) {
        this.Request.IntentActions[index].listValidation.splice(
          indexValidation,
          1
        );
      }
    },
    DeleteParallelAction(items) {
        items.isParallelAction = false;
        items.actionType = null;
        this.ChangeAction(items);
    },
    highlighter(code) {
      // ตรวจสอบว่าใช้ syntax นี้
      return highlight(code, languages.js);
    },
    formatText(text) {
      if (text === null || text === undefined) {
        return '';
      }
      return String(text).replaceAll(' ', "&nbsp;");
    },
    DeleteVectorByBtn(IntentAction, Id) {
      IntentAction.vectorDetail.splice(
        IntentAction.vectorDetail.findIndex((e) => e.tblVector == Id),
        1
      );
      if (this.Selected && Array.isArray(this.Selected[0])) {
        this.Selected[0] = this.Selected[0].filter((e) => e !== Id);
      }
      IntentAction.tblVector = this.Selected.join(",");
      this.dataTable.forEach((element) => {
        element.selected = false;
        const chk = this.Selected.find((e) => e == element.id);
        if (chk != undefined) {
          element.selected = true;
        }
      });
    },
    SelectVector(IntentAction, Flag, Id, TextORG) {
      if (Flag) {
        this.Selected.push(Id);
        IntentAction.tblVector = this.Selected.join(",");
        if (IntentAction.vectorDetail == null) {
          IntentAction.vectorDetail = [{ textORG: TextORG, tblVector: Id }];
        } else {
          IntentAction.vectorDetail.push({ textORG: TextORG, tblVector: Id });
        }
      } else if (this.Selected.includes(Id)) {
        // Check if Id exists in Selected
        this.Selected.splice(this.Selected.indexOf(Id), 1);
        IntentAction.vectorDetail.splice(
          IntentAction.vectorDetail.findIndex((e) => e.tblVector == Id),
          1
        );
        IntentAction.tblVector = this.Selected.join(',');
      }
    },
    CheckNewIntent(index) {
      if (this.Intent.length == index + 1) {
        this.Intent.push({ text: "" });
      }
      return true;
    },
    CheckDeleteIntent(index, value) {
      this.$nextTick(() => {
        const textareas = this.$refs.textareas;
        if (value == "" && index > 0 && this.Intent.length > 1) {
          this.Intent.splice(index, 1);
          if (textareas[index - 1]) {
            textareas[index - 1].focus();
          }
        }
        if (
          value == "" &&
          index <= this.Intent.length - 1 &&
          this.Intent.length > 1
        ) {
          this.Intent.splice(index, 1);
          if (textareas[index]) {
            textareas[index].focus();
          }
        }
      });
    },
    newLineEnter(index) {
      if (this.Intent.length >= index + 1) {
        this.Intent.push({ text: "" });
      }
      //cursor
      this.$nextTick(() => {
        const textareas = this.$refs.textareas;
        if (textareas[index + 1]) {
          textareas[index + 1].focus();
        }
      });
    },
    DeleteIntent(index) {
      if (this.Intent.length > 1) {
        this.Intent.splice(index, 1);
      }
    },
    onPaste(index, event) {
      const paste = event.clipboardData.getData("text");
      this.$set(this.Intent, index, { text: paste });
      if (this.Intent.length == index + 1) {
        this.Intent.push({ text: "" });
      }
    },
    getItemModelNameText(item) {
      return `${item.modelDisplayID}: ${item.name}`;
    },
    async GetModel() {
      await this.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDModelDisplayName = dataResponse.data;
          } else {
            this.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async Get() {

      this.dialog = true;
      this.$call.GetIntentSessionDetailById(
        this.id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.dialog = false;
            this.Binding(dataResponse.data);

          }
          this.GetModel();
          this.GetDDVectorName();
          this.GetIntentGroup();
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetByVector() {
      if (this.VectorName == "" || this.VectorName == null) {
        return;
      }
      this.dialog = true;
      this.loadingTable = true;

      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.VectorName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      this.$call.GetTableVector(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.table.total;
            this.dataTable = dataResponse.data.table.data;
            this.totalTable = dataResponse.data.table.total;
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
          this.ShowTable = true;
          this.dialog = false;
          this.dataTable.forEach((element) => {
            element.show = this.ShowAllText;
            element.selected = false;
            for (let index = 0; index < this.Selected.length; index++) { //NOSONAR
              const element2 = this.Selected.find(
                (e) => e == element.id
              );
              if (element2 != undefined) {
                element.selected = true;
              }
            }
          });
        },
        (errorResource) => {
          this.dialog = false;
          this.loadingTable = false;
          this.isSearch2 = false;
          console.error(errorResource);
        }
      );
    },
    SaveAdd() {
      if (!this.Request.Name || this.Request.Name.trim() === "") {
        this.showNameRequiredDialog = true;
        return;
      }
      if (this.validate()) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warningFillAll"),
          showConfirmButton: false,
          timer: 5000,
        });
        return;
      }
      this.Prepare(1);

      try {
        this.dialog = true;
        this.$call.CreateIntentSession(
          this.Request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.successMessage = this.$t('_intentSessionSaved');
              this.showSuccess = true;
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 2000);
              setTimeout(() => {
                this.$router.push({
                  name: "IntentSession",
                  query: {
                    id: this.Request.IntentGroupID,
                  },
                });
              }, 2000);
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
        console.log("catch : AddIntentSession");
      }
    },
    SaveEdit() {
      if (!this.Request.Name || this.Request.Name.trim() === "") {
        this.showNameRequiredDialog = true;
        return;
      }
      if (this.validate()) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warningFillAll"),
          showConfirmButton: false,
          timer: 5000,
        });
        return;
      }
      this.Prepare(2);
      try {
        this.dialog = true;
        this.$call.UpdateIntentSession(
          this.Request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.successMessage = this.$t('_intentSessionUpdated');
              this.showSuccess = false;
              this.$nextTick(() => {
                this.showSuccess = true;
              });
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 2000);
              setTimeout(() => {
                this.$router.push({
                  name: "IntentSession",
                  query: {
                    id: this.Request.IntentGroupID,
                  },
                });
              }, 2000);
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
        console.log("catch : UpdateIntentSession");
      }
    },
    Back() {
      this.$router.push({
        name: "IntentSession",
        query: {
          id: this.Request.IntentGroupID,
        },
      });
    },
    async GetIntentGroup() {
      this.dialog = true;
      await this.$call.DDIntentGroup(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDIntentGroup = dataResponse.data;
          } else {
            this.listDDIntentGroup = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetDDVectorName() {
      this.dialog = true;
      await this.$call.GetDDVectorDBName(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDVector = dataResponse.data;
          } else {
            this.DDVector = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    validate() {
      if (
        this.Request.Name == "" ||
        this.Request.Name == null ||
        this.Request.PromptSession == "" ||
        this.Request.PromptSession == null ||
        this.Request.IntentActions == null ||
        this.Request.IntentActions.length == 0 ||
        this.validateAction()
      ) {
        return true;
      }
      this.Request.Score = this.Request.Score == "" ? null : this.Request.Score;
      return false;
    },
    validateAction() {
      if (
        !this.Request.IntentActions ||
        !Array.isArray(this.Request.IntentActions)
      ) {
        return true;
      }
      let check = this.Request.IntentActions.filter(
        (e) => e.activeFlag == true //NOSONAR
      );
      return check.some((action) => {
        return (
          (action.actionType == "VT" &&
            (action.tblVector == "" || action.tblVector == null)) ||
          (action.actionType == "TR" &&
            (action.textResponse == "" || action.textResponse == null)) ||
          (action.actionType == "MR" &&
            (action.modelDisplayRouting == "" ||
              action.modelDisplayRouting == null)) ||
          (action.actionType == "NR" &&
            (action.nextRouting == "" || action.nextRouting == null)) ||
          (action.actionType == "CA" &&
            (action.botDisableTime == "" || action.botDisableTime == null))
        );
      });
    },
    Prepare(v) {
      this.Request.Intent = this.Intent.filter((e) => e.text !== "")
        .map((e) => e.text)
        .join(",");
      if(v == 1){
        if (this.Request.IntentActions.length > 1) {
          // Start from index 1 and filter out items with empty actionType
          const firstAction = this.Request.IntentActions[0];
          const restActions = this.Request.IntentActions.slice(1).filter(
            (action) => action.actionType !== "" && action.actionType !== null
          );
          this.Request.IntentActions = [firstAction, ...restActions];
        }
        this.Request.IntentActions.forEach(action => {
          if (action.botDisableTime === "" || action.botDisableTime === null) {
            action.botDisableTime = null;
          } else {
            action.botDisableTime = Number.parseInt(action.botDisableTime) || null;
          }
        });
      } else {
        if (this.Request.IntentActions.length > 1) {
          const firstAction = this.Request.IntentActions[0];

          // Process actions from index 1 onwards
          const restActions = this.Request.IntentActions.slice(1).map(action => {
            // If both actionType and intentActionID are empty/null, mark for removal
            const shouldRemove =
              (action.actionType === "" || action.actionType === null) &&
              (action.intentActionID === "" || action.intentActionID === null);

            // If actionType is empty but intentActionID exists, set activeFlag to false
            if ((action.actionType === "" || action.actionType === null) &&
                action.intentActionID !== "" && action.intentActionID !== null) {
              action.activeFlag = false;
            }

            return shouldRemove ? null : action;
          }).filter(action => action !== null); // Remove null items

          this.Request.IntentActions = [firstAction, ...restActions];
        }
        this.Request.IntentActions.forEach(action => {
          if (action.actionType == null || action.actionType == "") {
            action.actionType = "";
            action.listHeadersAPITrigger = [];
            action.listValidation = [];
          }
          if (action.botDisableTime === "" || action.botDisableTime === null) {
            action.botDisableTime = null;
          } else {
            action.botDisableTime = Number.parseInt(action.botDisableTime) || null;
          }
        });
      }
    },
    Binding(Source) {
      if (Source != null) {
        let intentArray = Source.intent.split(",");
        this.Intent = intentArray.map((intent) => ({ text: intent }));
        this.Intent.push({ text: "" });
        this.Request.Name = Source.name;
        this.Request.Score = Source.score;
        this.Request.UseMemory = Source.useMemory;
        this.Request.PromptSession = Source.promptSession;
        if (Source.intentAction.length > 0) {
          this.Request.IntentActions = Source.intentAction;
          const hasAnyMergePrompt = Source.intentAction.some(action => action.isMergePrompt === true);
          this.Request.UseBasePrompt = hasAnyMergePrompt;
          // this.Request.IntentActions.ListHeadersAPITrigger = Source.intentAction
          this.Request.IntentActions.forEach((element, index) => {
            element.isParallelAction = index > 0;
            if (element.actionType == "VT") {
              this.Selected[index] = element.tblVector.split(",").map(Number);
            }
          });
        }
      }
    },
    isEnter: function (evt, index) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 13) {
        evt.preventDefault();
      } else {
        this.CheckNewIntent(index);
        return true;
      }
    },
    downloadTemplate() {
      // สร้าง workbook และ worksheet ใหม่
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Template");

      // เพิ่มข้อมูลลงในเวิร์กชีต
      worksheet.addRow(["Intent text"]);
      worksheet.addRow(["หมีเนยคือใคร?"]);
      worksheet.addRow(["หมีเนยอายุเท่าไหร่?"]);
      worksheet.addRow(["สถานะภาพของหมีเนยคือ?"]);

      // ดาวน์โหลดไฟล์
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "intent_text_template.xlsx";
        a.click();
        globalThis.URL.revokeObjectURL(url);
      });
    },
    processUpload(event) {
      this.files = event;
      if (this.files.length === 0) {
        this.uploadedFiles = [];
        return;
      }

      const reader = new FileReader();
      const file = this.files[0];
      reader.onload = async (e) => {
        const workbook = new ExcelJS.Workbook();
        try {
          const buffer = e.target.result;
          await workbook.xlsx.load(buffer);

          // อ่านข้อมูลจาก worksheet แรก
          const worksheet = workbook.worksheets[0];
          const jsonData = [];

          // แปลงข้อมูลจาก worksheet เป็น array 2 มิติ
          worksheet.eachRow((row, rowNumber) => {
            const rowData = [];
            row.eachCell((cell) => {
              rowData.push(cell.value);
            });
            jsonData.push(rowData);
          });

          // ข้ามแถวแรกที่เป็นหัวข้อ
          this.DataRowUpload = jsonData.slice(1);
          this.ValidateFile(this.files);
          this.showConfirmDialog = true;
        } catch (error) {
          console.error("Error reading Excel file:", error);
          this.$swal.fire({
            icon: "error",
            title: this.$t('_errorReadingExcel'),
            text: this.$t('_fileFormatNotSupported'),
          });
        }
      };
      reader.readAsArrayBuffer(file); //NOSONAR
    },
    ValidateFile(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("upload_file", files[0]);
      this.uploadedFiles = files;
      this.entity = formDataDoc;
    },
    ConfirmProcess() {
      const newData = this.DataRowUpload.map((row) => {
        return { text: row.join(" ") };
      });
      this.showConfirmDialog = true;
      if (this.Intent.length > 0) {
        this.Intent = this.Intent.filter(
          (item) => item.text.trim() !== ""
        );
        this.Intent = [...this.Intent, ...newData];
      } else {
        this.Intent = newData;
      }
      this.showConfirmDialog = false;

      // self.$swal
      //   .fire({
      //     title: this.$t("importIntentText"),
      //     icon: "warning",
      //     showCancelButton: true,
      //     confirmButtonColor: "#3085d6",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: this.$t("yes"),
      //     cancelButtonText: this.$t("cancel"),
      //   })
      //   .then((result) => {
      //     if (result.isConfirmed) {
      //       const newData = self.DataRowUpload.map((row) => {
      //         return { text: row.join(" ") };
      //       });

      //       if (self.Intent.length > 0) {
      //         self.Intent = self.Intent.filter(
      //           (item) => item.text.trim() !== ""
      //         );
      //         // ถ้ามีข้อมูลอยู่แล้ว ให้ต่อข้อมูลใหม่เข้าไปใน Intent เดิม
      //         self.Intent = [...self.Intent, ...newData];
      //       } else {
      //         self.Intent = newData;
      //       }
      //     }
      //   });
    },
  },
  async mounted() {
    this.GetDate();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.Request.IntentSessionID = this.$route.query.id;
      this.Request.IntentGroupID = this.$route.query.idGroup;
      await this.Get();
    } else if (this.$route.query.idGroup) {
      this.Request.IntentGroupID = this.$route.query.idGroup;
      this.AddEvent = true;
      await this.GetModel();
      await this.GetDDVectorName();
      await this.GetIntentGroup();
    }
    this.AddNewAction();
  },
};
</script>
<style scoped>
.dialog-upload-card {
  margin-top: -106px;
}

.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #158638 0%, #135928 100%) !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}
.parallel-action-delete {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn-hover-none:hover {
  background: none !important;
}

.btn-hover-pink:hover {
  background: #FDE4DF !important;
}
.selected-chunks-design {
  display: flex;
  align-items: center !important;
  background: #ffffff !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(23,23,23,0.11) !important;
  padding: 6px !important;
  gap: 8px !important;
  width: 100px;
  overflow: hidden;
}
.chip-text-design {
  color: #171717;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60px;
  display: inline-block;
}
/* Confirm upload */
.confirm-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: linear-gradient(100deg, #E7EBFF 0%, #FFFFFF 100%) !important;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #001763 !important;
}
.body-text {
  font-size: 12px;
  color: #171717;
}
.cancel-btn {
  border: 1px solid #949AA8;
  border-radius: 12px;
  height: 40px;
  padding: 4px 16px;
}
.confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px !important;
  width: 100px;
  height: 38px;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
}

.input-clearable {
  height: 50px;
}
.btn-action-design {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 108px;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 8px;
}
.btn-action-design:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.validation-card {
  display: flex;
  flex-direction: row;
  padding: 12px;
}
.text-response {
  display: flex;
  align-items: center;
  gap: 6px;
}
.text-response-textarea {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  padding: 0 12px;
  color: #171717;
  margin-bottom: 16px;
}
.text-response-textarea::placeholder {
  color: #cccccc;
}
.intent-action-btn-wrapper {
  padding: 12px 18px;
}
.intent-action-btn {
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 12px;
  gap: 6px;
  background: #3859D0;
}
.intent-action-btn:hover {
  opacity: 0.7;
}
.intent-text {
  color: #FFFFFF;
  font-size: 14px;
}
.add-example-section {
  display: flex;
  align-items: center;
  border: 1px solid #C32E0E;
  border-radius: 8px;
  padding: 8px 12px;
  gap: 6px;
}
.add-example-section:hover {
  background: #FDE4DF;
}
.textarea-style {
  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  border-radius: 10px;
  padding: 0 12px;
}
.heading-text {
  color: #171717;
  font-weight: 600;
}
.card-box {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  padding: 0px 12px;
  margin-top: 5px;
}
.use-memory-card.state-on {
  background: #FFF2F2 !important;
}
.use-memory-card.state-off { 
  background: #EDEDED !important;
}
.cart-top {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}
.cart-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.col-control {
  display: flex;
  justify-content: start;
  align-items: center;
}
.action-divider {
  width: 2px;
  height: 72px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
}
.intent-session-name{
  background: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  width: 40%;
  height: 44px;
  padding: 8px;
}
.intent-session-name:focus {
  border: 1px solid #c9c9c9;
  outline: 0px solid #c9c9c9;
}
.intent-session-name::placeholder {
  color: #CCCCCC;
}
.label-style {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.card2 {
  border: 1px solid rgba(201, 201, 201, 1) !important;
  border-radius: 10px !important;
  box-shadow: none;
  padding: 10px;
}

/* Header Styling */
.header-title {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  border-radius: 16px 16px 0 0 !important;
}

/* Modern Expansion Panels */
.modern-panel {
  box-shadow: none !important;
  border-radius: 10px;
}

.panel-header {
  background: rgba(254, 225, 219, 1) !important;
  padding: 10px !important;
}
.intent-panel-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px !important;
  border-radius: 10px;
}
.intent-panel-open {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
}
.intent-panel-closed {
  background: rgba(254, 225, 219, 1) !important;
  color: #C32E0E;
}
.intent-left {
  gap: 8px;
  display: flex;
  align-items: center;
}
.intent-right {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-design {
  border: 1px solid #C9C9C9;
  border-radius: 10px;
  box-shadow: none;
  background: #ffffff;
  margin-top: 8px;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  margin-bottom: 12px;
}
.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: start;
  margin-left: 8px;
}
.card-action-title {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: start;
}
.template-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 6px 16px !important;
  margin-top: 2px;
}
.template-btn:hover {
  background: #FDE4DF;
  box-shadow: none !important;
}
:deep(.UploadFile .upload-button) {
  gap: 4px;
  height: 35px;
  padding: 4px 16px !important;
}
:deep(.UploadFile .upload-button span) {
  font-size: 13px !important;
}
.UploadFile {
  padding: 4px 12px;
}
.panel-body {
  display: flex;
  align-items: center;
  gap: 8px;
}
.example-text, .action-text {
  font-size: 14px;
  font-weight: 600;
}

.header-text {
  font-size: 14px;
  font-weight: 600;
  color: #171717;
}

.panel-content {
  padding: 24px !important;
}

.transition-transform {
  transition: transform 0.3s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}

/* Intent Container */
.intent-container {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: none !important;
  border: none;
}

.intent-item {
  display: flex;
  align-items: flex-start;
  transition: background-color 0.2s ease;
}

.intent-item:hover {
  background-color: rgba(25, 118, 210, 0.02);
}

.intent-item:hover .delete-intent-btn {
  opacity: 1;
}

.intent-number {
  background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
  padding: 16px 20px;
  font-weight: 600;
  color: #666;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.intent-textarea {
  flex: 1;
  padding: 8px 16px;
}

.delete-intent-btn {
  opacity: 0;
  transition: opacity 0.2s ease;
  margin: 8px;
}

/* Action Cards */

.action-container {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
}

.action-section {
  padding: 0 18px;
  background: #ffffff;
  width: 100%;
  margin-top: 4px;
}

.action-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.action-type-badge {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.875rem;
}

.action-type-badge.action-answer {
  background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
  color: white;
}

.action-type-badge.action-parallel {
  background: #E8F1FB;
  color: #0D47A1;
  border: 1px solid rgba(25, 118, 210, 0.3);
}

.action-type-text {
  font-weight: 600;
}

.delete-action-btn {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.delete-action-btn:hover {
  opacity: 1;
}

/* Section Titles */
.section-title-simple {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1);
}

.section-title-simple .text-h6 {
  color: #1976d2;
  font-weight: 600;
}

/* Selected Vector Chips */
.selected-vectors {
  background: #EFF4FF;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #C9C9C9;
}

.selected-vector-chip {
  margin: 4px !important;
  font-weight: 500 !important;
  display: inline-flex !important;
  align-items: center !important;
  max-width: 200px !important;
}

/* Vector Table */
.vector-table {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

/* JSON Editor */
.json-editor-container {
  background: white;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.json-variables {
  background: #f8f9fa;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.variables-header {
  margin-bottom: 12px;
  font-weight: 600;
  color: #666;
  font-size: 0.875rem;
}

.variables-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}

.variable-chip {
  position: relative;
  cursor: pointer !important;
}
.variable-chip:hover {
  background: rgba(56, 89, 208, 0.1) !important;
}
.variable-chip:active {
  background: rgba(56, 89, 208, 0.1) !important;
}

.modern-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: "Fira Code", "Fira Mono", Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  min-height: 200px;
  position: relative;
  transition: all 0.2s ease;
}

/* Add Action Button */
.add-action-btn {
  border: 2px dashed #1976d2 !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border-radius: 12px !important;
  padding: 16px !important;
  transition: all 0.3s ease !important;
  width: 80px !important;
}

.add-action-btn:hover {
  background: rgba(25, 118, 210, 0.08) !important;
  transform: translateY(-2px);
}

.action-card-wrapper {
  position: relative;
}

.action-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: 2px solid transparent !important;
}

.action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.action-answer {
  background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%) !important;
  border-color: #9c27b0 !important;
}

.action-answer .action-title {
  color: white !important;
}

.action-parallel {
  background: white !important;
  border-color: #e0e0e0 !important;
}

.action-parallel .action-title {
  color: #1976d2 !important;
}

.action-title {
  padding: 20px 24px !important;
  border-radius: 16px 16px 0 0 !important;
  display: flex;
  align-items: center;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
}

.text-container {
  display: flex;
  align-items: flex-start;
  max-width: 100%;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
}

.text-content-show {
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
}

/* Selected Vector Chips */

/* API Sections */
.api-section {
  background: rgba(248, 249, 250, 0.5);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-weight: 600;
  font-size: 1rem;
  color: #1976d2;
}

.header-row,
.validation-row {
  background: white;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* Form Controls */
:deep(.v-field) {
  border-radius: 8px !important;
}

:deep(.v-field--outlined) {
  border: 1.5px solid rgba(0, 0, 0, 0.12) !important;
}

:deep(.v-field--focused) {
  border-color: #1976d2 !important;
}

:deep(.v-input--density-comfortable) {
  --v-input-control-height: 48px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .panel-content {
    padding: 16px !important;
  }

  .action-title {
    padding: 16px !important;
    font-size: 1rem !important;
  }
  .action-section {
    padding: 16px;
  }

  .action-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .api-section {
    padding: 16px;
  }

  .variables-grid {
    flex-direction: column;
    gap: 4px;
  }

  .variable-chip {
    width: 100%;
    justify-content: center;
  }

  .modern-editor:deep(.prism-editor-wrapper.drag-over::before) {
    font-size: 10px;
    padding: 6px 12px;
  }
}

/* Animation for smooth transitions */
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}


@keyframes dragPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(25, 118, 210, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
}

/* Drop zone styling */
.modern-editor:deep(.prism-editor-wrapper) {
  border: 2px solid transparent;
  transition: all 0.2s ease;
  position: relative;
}

.modern-editor:deep(.prism-editor-wrapper.drag-over) {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.08);
  box-shadow: 0 0 0 4px rgba(25, 118, 210, 0.1);
}

.modern-editor:deep(.prism-editor-wrapper.drag-over::before) {
  content: "Drop variable here";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(25, 118, 210, 0.9);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
  pointer-events: none;
}
.time-field-container {
  max-width: 300px;
}

.time-unit {
  font-size: 0.875rem;
  font-weight: 500;
}

.info-icon {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 1;
}


/* Selected Vector Chips */
.selected-vector-chip .chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

/* ปรับแต่ง chip ให้แสดงปุ่ม close อย่างถูกต้อง */
.selected-vector-chip :deep(.v-chip__content) {
  display: flex !important;
  align-items: center !important;
  max-width: 100% !important;
  overflow: hidden !important;
}

.selected-vector-chip :deep(.v-chip__close) {
  flex-shrink: 0 !important;
  margin-left: 4px !important;
  order: 2 !important;
}

/* ปรับให้ข้อความไม่ไปทับปุ่ม close */
.selected-vector-chip :deep(.v-chip__content > span) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.example-questions-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
}

.example-input-row {
  display: flex;
  align-items: center;
  gap: 18px;
  background: #ffffff;
  padding: 6px 10px;
  min-height: 34px;
}


.example-info-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  color: #1E2E7A;
  background: #EBEEFA;
  border-radius: 50%;
  flex-shrink: 0;
  user-select: none;
}

.example-input {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  border: 1px solid #DCDCDC;
  border-radius: 8px;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  color: #171717;
  background: #ffffff;
  padding: 4px 12px;
  height: 48px;
}

.example-input::placeholder {
  color: #cccccc;
  font-weight: 400;
}


@media (max-width: 600px) {
  .example-input-row {
    padding: 6px 8px;
    gap: 6px;
  }
  .example-info-icon { font-size: 10px; }
}

/* Required Name Dialog Styles */
.required-name-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
  border: 1px solid #F4D6B8;
}

.required-name-header {
  background: linear-gradient(900deg,#FFF8ED, #FFF0DA);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #FFA726;
}
.required-body {
  padding: 16px;
}
.required-name-message {
  font-size: 14px;
  color: #171717;
}
.required-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.ok-required-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #ffffff !important;
  width: 104px;
  background: #B45800;
}

.required-name-dialog :deep(.v-divider) {
  border-color: #F4D6B8 !important;
}

.required-name-dialog .close-btn {
  color: #B45800;
}

.required-name-dialog .close-btn:hover {
  color: #8C3F00;
}

.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}

.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}

/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;
  
}

.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}

.memory-switch :deep(.v-switch__loader) { display: none !important; }
.v-input--density-default {
    --v-input-control-height: none;
}

/* Validation card styling */
.validation-item-card {
  border: 1px solid #E5E5E5;
  padding: 16px 18px 20px;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: none;
}

.validation-item-card .validation-label {
  font-size: 14px;
  font-weight: 400;
  color: #171717;
  display: inline-block;
  margin-bottom: 4px;
}

.validation-item-card :deep(.v-field) {
  border-radius: 10px !important;
}

.validation-item-card :deep(.v-textarea .v-field) {
  min-height: 90px;
}

/* Brown dropdown color (#872612) for Validation Type */
.validation-type-autocomplete :deep(.v-field__input) {
  font-size: 14px;
  color: #171717;
  font-weight: 500;
}

.validation-type-autocomplete :deep(.v-select__selection) {
  color: #171717 !important;
}

.validation-type-autocomplete :deep(.v-field__outline) {
  --v-field-border-color: #c9c9c9;
}

.validation-type-autocomplete :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
  width: 40px;
  height: 40px;
}

.validation-type-autocomplete :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 600;
}

.validation-type-autocomplete :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}

</style>